import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import {PropType} from "vue";

export function useMessageTypeProps() {
    return {
        message: {
            type: Object as PropType<MessageWrapper>,
            required: true
        }
    }
}